export const ADD_MOVEMENTS = 'ADD_MOVEMENTS'
export const ADD_TYPE_REASONS = 'ADD_TYPE_REASONS'
export const LOAD_MOVEMENT_LINE_STATUS = 'LOAD_MOVEMENT_LINE_STATUS'
export const LOAD_MOVEMENT_STATUS = 'LOAD_MOVEMENT_STATUS'